
    import React from 'react';
    import { useCommitteeCreate, useCommitteeSoftDelete,useCommitteeMultipleSoftDelete, useCommitteeUpdate } from '../../queries/Committee.queries';
    import Committee from './Committee';
    
    const CommitteeContainer = () => {
    
      const {mutate:addRecord} = useCommitteeCreate();
      const {mutate:editRecord} = useCommitteeUpdate();
      const {mutate:deleteRecord} = useCommitteeSoftDelete();
      const {mutate:deleteRecords} = useCommitteeMultipleSoftDelete();
    
      const onAddRecord = (record) => {
        return new Promise((resolve,reject) => {
          addRecord(record, {
            onSuccess: async () => resolve('Record created successfully.'),
            onError: async (error) => reject(error?.message),
          });
        })
      };
    
      const onEditRecord = (record) => {
        return new Promise((resolve, reject) => {
          editRecord(
            record,
            {
              onSuccess: async () => resolve('Record updated successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
    
      const onDeleteRecord = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecord(
            record, 
            {
              onSuccess: async () => resolve('Record deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      const onMultiDelete = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecords(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      return (
        <Committee 
          addRecord={onAddRecord}
          deleteRecord={onDeleteRecord}
          deleteRecords={onMultiDelete}
          editRecord={onEditRecord}
        />
      )
    }
    
    export default CommitteeContainer;
    